import { Injectable } from '@angular/core';
import {
  BasePageMetaResolver,
  TranslationService,
  PageLinkService,
  BreadcrumbMeta,
  ProductPageMetaResolver,
  ProductService,
  RoutingService,
} from '@spartacus/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { REQUEST_URL } from '../../request-url.token';
import { Inject, Optional } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class KbProductPageMetaResolver extends ProductPageMetaResolver {
  constructor(
    protected override routingService: RoutingService,
    protected override productService: ProductService,
    protected override translation: TranslationService,
    protected override basePageMetaResolver: BasePageMetaResolver,
    protected override pageLinkService: PageLinkService,
    @Optional() @Inject(REQUEST_URL) private requestUrl?: string
  ) {
    super(routingService, productService, translation, basePageMetaResolver, pageLinkService);
  }

  override resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
    return combineLatest([this.product$.pipe(), this.translation.translate('common.breadcrumb_home')]).pipe(
      map(([product, label]) => {
        const breadcrumbs = [];
        breadcrumbs.push({ label, link: '/' });
        for (const { name, url } of product.breadcrumbs || []) {
          breadcrumbs.push({
            label: name,
            link: url,
          } as BreadcrumbMeta);
        }
        return breadcrumbs;
      })
    );
  }
  override resolveDescription(): Observable<string> {
    return this.product$.pipe(
      switchMap((product: any) =>
        this.translation.translate('pageMetaResolver.product.description', {
          description: [product?.code, product?.name, product?.typenumber, product?.countryOfOrigin, product?.description].filter((v) => v !== undefined && v !== null && (String(v)?.trim()?.length ?? 0) > 0).join(', ')
        })
      )
    );
  }
  override resolveTitle(): Observable<string> {
    return this.product$.pipe(
      switchMap((product) => {
        let title = `${product.code} | ${product.name} `;
        title += this.resolveFirstCategory(product);
        title += this.resolveManufacturer(product);
        return this.translation.translate('pageMetaResolver.product.title', {
          title: title,
        });
      })
    );
  }
  /* override resolveCanonicalUrl(): Observable<string> {
    return this.product$.pipe(
      switchMap((product) => this.findBaseProduct(product)),
      map((product) => {
        const url = this.routingService.getFullUrl({
          cxRoute: 'product',
          params: product,
        });
        console.log(url);
        return this.pageLinkService.getCanonicalUrl({}, url);
      })
    );
  } */
  override resolveCanonicalUrl(): Observable<string> {
    return of(this.requestUrl ?? '');
  }
}
